import { dataMember, required, typedArray } from 'santee-dcts';
import { Readable, Acknowledgement } from '../../../view-history';
import { SubjectNaturalKey } from '../../../subjects';
import { ExternalUserEQuery } from '../../../e-queries/models/external-user-e-query';

export class InvestigatorEQuery extends ExternalUserEQuery implements Readable {
     @dataMember()
     @typedArray(Acknowledgement)
     @required()
     public viewHistory: Acknowledgement[];

     @dataMember()
     @required()
     public isRead: boolean;

     @dataMember()
     @required()
     public isReadByMe: boolean;

     public get zcSubjectId(): string | null {
          const result = SubjectNaturalKey.fromString(this.subjectNaturalKey);

          return result
              ? result.zcSubjectId
              : null;
      }
}

export class InvestigatorEQueryCountersReadModel {
     @dataMember()
     @typedArray(InvestigatorEQuery)
     public eQueries : InvestigatorEQuery[];
}
